<script lang="ts">
	import { classes } from '$lib/utils';
	import ChevronRightIcon from '../Icon/ChevronRightIcon.svelte';

	export let index: number;
	// export let listLength: number;
	// export let showAllEntries: boolean = true;
	export let course: { name: string | null; slug: string | null };
	// TODO: Further abstraction possible through exporting the slug prefix
	// for the href={`/courses/${course.slug}`} instead of hardcoding /courses/
	export let additionalClass: string = '';
</script>

<div class={classes(additionalClass, 'border-r border-l border-black p-4 !bg-white z-10')}>
	<a
		class="flex flex-row justiy-center items-center gap-3 cursor-pointer select-none !bg-white"
		href={`/courses/${course.slug}`}
	>
		<div
			class="flex flex-row border text-purple border-purple rounded-full text-xs font-bold min-w-[32px] min-h-[32px] w-8 h-8 items-center justify-center"
		>
			{index + 1}
		</div>

		<div>
			{course.name}
		</div>
		<div class="ml-auto">
			<ChevronRightIcon />
		</div>
	</a>
</div>
